import React from "react";
import { FormBox } from "./FormBox";
import { TopButs } from "./TopButs";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottoms";
import { MaterialDialog } from "./MaterialDialog";
import { SettleDrawer } from "./SettleDrawer";
import { WhConfirmDrawer } from "./WhConfirmDrawer";

export default (props) => {
    const { mode } = props;
    return (
        <div className="yh-detail-box">
            {mode !== "add" && <TopButs {...props} />}
            <FormBox {...props} />
            <TableBox {...props} />
            <FixedBottom {...props} />
            <MaterialDialog {...props} />
            <SettleDrawer {...props} />
            <WhConfirmDrawer {...props} />
        </div>
    )
}